import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useCurlLogger } from "../../useCurlLogger";

export interface IConfigurationClinicImagesPutBody {
  image_version: {
    image_base64: string;
    image_extension: string;
  };
  clinic_listing_page: Record<string, { base_64: string[]; image_extension: string }>;
  clinic_details_page: Record<string, { base_64: string[]; image_extension: string }>;
}

interface IConfigurationClinicImagesUpdateResponse {
  status: boolean;
  message: string;
  data?: { clinic_id?: string } | null;
}

AxiosCurlirize(axios, () => {});

export const useConfigurationClinicImagesUpdateAPI = () => {
  const [updatedImagesClinicId, setUpdatedImagesClinicId] = useState<string>("");
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (imagesData: IConfigurationClinicImagesPutBody, clinicId: string) => {
      if (!imagesData || !clinicId) {
        return;
      }
      setIsUpdating(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IConfigurationClinicImagesUpdateResponse> = await axios.put(
          `${CONFIGURATION_APIS?.CLINIC_IMAGES?.baseURL}${clinicId}/`,
          imagesData,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (res.data?.status) {
          toast.success(res.data?.message);
          setUpdatedImagesClinicId(res.data?.data?.clinic_id || clinicId);
        } else {
          setUpdatedImagesClinicId("");
          toast.error(res.data?.message);
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          if (error.config?.["curlCommand"]) {
            sendCurl(error.config["curlCommand"]);
          }
          captureError(error);
          toast.error((error.response?.data as any)?.message || error.message);
        } else {
          toast.error("Server Error: " + (error as Error).message);
        }
      } finally {
        setIsUpdating(false);
      }
    },
    [captureError, configuration, sendCurl],
  );

  return { updatedImagesClinicId, isUpdating, execute };
};
